import { cn } from "@/lib/utils";
import { Star } from "lucide-react";

import { formatProductRatingLabel, shouldShowProductRating } from "./smart-catalog.utils";

type Props = {
    avg?: number | null;
    count?: number | null;
    className?: string;
};

/** Note produit — ex. ★ 4,5/5 (198). Masquée sous le seuil d'avis. */
export function ProductRating({ avg, count, className }: Props) {
    if (!shouldShowProductRating(avg, count)) return <span className="text-xs text-gray-400">—</span>;

    return (
        <span className={cn("inline-flex items-center gap-0.5 text-xs text-gray-500", className)}>
            <Star className="size-3 shrink-0 fill-amber-400 text-amber-400" aria-hidden />
            <span>{formatProductRatingLabel(avg!, count!)}</span>
        </span>
    );
}
